var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exhibition-board-container"},[_vm._m(0),_c('div',{staticClass:"card-box-container"},_vm._l((_vm.classesList),function(info,index){return _c('Card',{key:index,attrs:{"info":info}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('span',{staticClass:"dot"}),_vm._v("根据站点类型，点击下方卡片进行站点创建")])
}]

export { render, staticRenderFns }